// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1tTuc","image":"Header_image__29tK9","name":"Header_name__33VVd","info":"Header_info__L1cxH","infoRow":"Header_infoRow__3l1XT"};